import { render, staticRenderFns } from "./Sider.vue?vue&type=template&id=7a2f0532&"
import script from "./Sider.vue?vue&type=script&lang=ts&"
export * from "./Sider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports